import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    Output,
    Renderer2,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import Debug from 'debug';
import { AumFormField } from './../aumFormField/aum-form-field';

const debug = Debug('aumico:aumico-lib-core-fe:AumSearch');

/**
 * to overwrite the with you have to change the css of .mat-form-field-infix
 */
@Component({
    selector: 'aum-search',
    styleUrls: ['./../aumFormField/aum-form-field.scss', './aum-search.scss'],
    templateUrl: './aum-search.html',
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AumSearch),
            multi: true,
        },
    ],
    host: {
        class: 'aum-form-field aum-search',
    },
    inputs: ['size'],
})
export class AumSearch extends AumFormField implements AfterViewInit {
    @ViewChild('input', { static: true }) el: ElementRef;

    constructor(
        el: ElementRef,
        changeDetectorRef: ChangeDetectorRef,
        renderer: Renderer2,
        matIconRegistry: MatIconRegistry,
        domSanitizer: DomSanitizer,
    ) {
        super(el, changeDetectorRef, renderer, matIconRegistry, domSanitizer);

        this.addSvgIcon('aumico-pattern-icon-search');
    }

    ngAfterViewInit() {
        const randomString = Math.random().toString(36).slice(-6);
        this.renderer.setAttribute(this.el.nativeElement, 'name', randomString);
        this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', randomString);
    }

    @Output()
    public search = new EventEmitter();

    public _onSearch() {
        debug('search');
        this.search.emit(this.aumFormControl.value);
    }
}
